import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = ["canvas", "signatureInput"]

  connect() {
    this.signaturePad = new SignaturePad(this.canvasTarget, {
      backgroundColor: "rgba(255, 255, 255, 1)",
      penColor: "rgb(0, 0, 0)",
      minWidth: 0.5,
      maxWidth: 2.5,
      throttle: 16,
      minDistance: 5
    })

    // Resize the canvas to fit the container
    this.resizeCanvas()

    // Listen for window resize
    window.addEventListener("resize", this.resizeCanvas.bind(this))

    // Update hidden input when signature changes
    this.signaturePad.addEventListener("endStroke", () => {
      this.updateSignatureInput()
    })
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeCanvas.bind(this))
  }

  clear() {
    this.signaturePad.clear()
    this.signatureInputTarget.value = ""
  }

  resizeCanvas() {
    const canvas = this.canvasTarget
    const rect = canvas.getBoundingClientRect()
    
    // Set actual size in memory (scaled to account for extra pixel density)
    const dpr = window.devicePixelRatio || 1
    canvas.width = rect.width * dpr
    canvas.height = rect.height * dpr
    
    // Scale the drawing context so everything will work at the higher DPI
    const ctx = canvas.getContext("2d")
    ctx.scale(dpr, dpr)
    
    // Scale back down using CSS
    canvas.style.width = rect.width + "px"
    canvas.style.height = rect.height + "px"
    
    // Redraw the signature if it exists
    if (this.signaturePad) {
      this.signaturePad.clear()
    }
  }

  updateSignatureInput() {
    if (!this.signaturePad.isEmpty()) {
      const dataURL = this.signaturePad.toDataURL()
      this.signatureInputTarget.value = dataURL
    } else {
      this.signatureInputTarget.value = ""
    }
  }
}
